<ng-container [formGroup]="form">
  <app-withdrawal-application-selector
    [form]="form"
    [options]="transactionOptions"
    [variant]="applicationSelectorVariant"
  />

  <div class="row two-col">
    <div class="col">
      <label for="firstName">Vorname</label>
      <input
        type="text"
        formControlName="firstName"
        placeholder="Vorname"
        id="firstName"
      />
    </div>
    <div class="col">
      <label for="lastName">Nachname</label>
      <input
        type="text"
        formControlName="lastName"
        placeholder="Nachname"
        id="lastName"
      />
    </div>
  </div>

  <div class="row">
    <label for="email">E-Mail-Addresse</label>
    <input
      type="email"
      formControlName="email"
      placeholder="E-Mail-Addresse"
      id="email"
    />
  </div>

  <div class="row hasError" *ngIf="hasError">
    <span class="errorIcon">!</span>{{ errorMessage }}
  </div>

  <div class="row align-right">
    <button type="submit" [disabled]="isSubmitting">
      Widerruf bestätigen
      <span *ngIf="isSubmitting" class="loader"></span>
    </button>
  </div>
</ng-container>
